import { useState, useEffect } from 'react';

export const useLocalStorage = (key, initialValue) => {
    // Estado para almacenar nuestro valor
    // Pasa la función inicial al useState para que solo se ejecute una vez
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error(`Error reading localStorage key "${key}":`, error);
            return initialValue;
        }
    });

    // Función para establecer el valor
    const setValue = (value) => {
        try {
            // Permite que el valor sea una función para que tengamos la misma API que useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.error(`Error setting localStorage key "${key}":`, error);
        }
    };

    // Función para eliminar el valor
    const removeValue = () => {
        try {
            setStoredValue(initialValue);
            window.localStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing localStorage key "${key}":`, error);
        }
    };

    // Función para limpiar todo el localStorage
    const clearAll = () => {
        try {
            window.localStorage.clear();
            setStoredValue(initialValue);
        } catch (error) {
            console.error('Error clearing localStorage:', error);
        }
    };

    return [storedValue, setValue, removeValue, clearAll];
};
